import TableTooltip from '../../controls/TableTooltip'

export default function ReportEditConfigErrorTooltip () {}

ReportEditConfigErrorTooltip.prototype = new TableTooltip();


ReportEditConfigErrorTooltip.prototype.updateUI = function ( config )
{
    this._tooltipTextPlaceholder.html(config.errorMessage) ;
    if (this.previousClass){
        this._tooltipEl.removeClass(this.previousClass);
    }
    this._tooltipEl.addClass(config.styleClass);
    this.previousClass = config.styleClass;
};



// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ReportEditConfigErrorTooltip.js